import { initializeApp, type FirebaseApp, type FirebaseOptions } from "firebase/app"
import { getAuth, type Auth } from "firebase/auth"

/**
 * Firebase Auth resuelve la identidad. La autorizacion (rol x alcance x capacidad)
 * vive en Postgres y la resuelve el backend: aqui NUNCA se leen custom claims
 * para decidir permisos.
 */
const options: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

export const isFirebaseConfigured = Boolean(
  options.apiKey && options.authDomain && options.projectId,
)

let app: FirebaseApp | null = null
let authInstance: Auth | null = null

if (isFirebaseConfigured) {
  app = initializeApp(options)
  authInstance = getAuth(app)
} else if (import.meta.env.DEV) {
  // Sin credenciales la SPA sigue levantando en modo mock (VITE_USE_MOCKS).
  console.warn(
    "[auth] Firebase no esta configurado. Completa las variables VITE_FIREBASE_* en .env.local.",
  )
}

export const firebaseApp = app
export const firebaseAuth = authInstance

/** ID token vigente, o null si no hay sesion. */
export async function getIdToken(forceRefresh = false): Promise<string | null> {
  const user = authInstance?.currentUser
  if (!user) return null
  return user.getIdToken(forceRefresh)
}
